// extracted by mini-css-extract-plugin
export var absolute = "DivOutline-module--absolute--cf80f";
export var border = "DivOutline-module--border--b0f3f";
export var btn = "DivOutline-module--btn--3f8ec";
export var btnLongText = "DivOutline-module--btnLongText--f4efe";
export var content = "DivOutline-module--content--d5bfa";
export var subHeading = "DivOutline-module--subHeading--95809";
export var tabletOnly = "DivOutline-module--tablet-only--2ac68";